import React, { useContext } from 'react';
import classNames from 'classnames';
import StudioHeader from '@/pages/home/pages/studio/components/StudioHeader';
import { StudioContext } from '../../context';
import { IStudioInfo } from '../../type';
import './index.scss';

interface IProps {
  children: React.ReactNode;
  studioInfo: IStudioInfo;
  pageType?: string;
  /** 追加在 `.dbh-studio-context` 上，用于 PR 等子布局换肤 */
  contextClassName?: string;
  /** 自定义顶栏（传入后不再渲染默认 StudioHeader） */
  header?: React.ReactNode;
  /** 背景图额外 class，如 casual hub */
  bgClassName?: string;
  /**
   * 仅 casual：背景 fallback 与重构前 CasualHub 保持一致
   * studio_background_url → studio_info.background_url（不再用首个游戏背景）
   */
  casualHubBgFallback?: boolean;
}
// 公共头部组件
const HeaderWrap = (props: IProps) => {
  const {
    studioInfo,
    children,
    pageType,
    contextClassName,
    header,
    bgClassName,
    casualHubBgFallback = false,
  } = props;
  const { currentGame } = useContext(StudioContext);

  const isStudio = pageType === 'studio';
  const studioInfoMeta = studioInfo?.data?.studio_info;
  const studioBackground = casualHubBgFallback
    ? (studioInfoMeta?.studio_background_url || studioInfoMeta?.background_url)
    : (studioInfoMeta?.studio_background_url ||
      studioInfo?.data?.game_list?.[0]?.background_url);
  const gameBackground = currentGame?.background_url;
  const backgroundUrl = (isStudio ? studioBackground : gameBackground) || '';

  return (
    <>
      <div
        className={classNames('dbh-studio-bg', bgClassName)}
        style={{ backgroundImage: `url(${(backgroundUrl)})` }}
      />
      <div className="dbh-studio-contextbox">
        {header !== undefined ? header : <StudioHeader studioInfo={studioInfo}/>}
        <div className={classNames('dbh-studio-context', contextClassName)}>
          {children}
        </div>
      </div>
    </>
  );
};

export default HeaderWrap;
